export const EMastraAgentId = {
  OrchestratorAgent: "OrchestratorAgent",
  PayrollSpecialistAgent: "PayrollSpecialistAgent",
  HrSpecialistAgent: "HrSpecialistAgent",
  ReportingSpecialistAgent: "ReportingSpecialistAgent",
  MigrationsSpecialistAgent: "MigrationsSpecialistAgent",
} as const;

export type TMastraAgentId =
  (typeof EMastraAgentId)[keyof typeof EMastraAgentId];
